import { render, staticRenderFns } from "./resourceInfo2.vue?vue&type=template&id=5e16a6ba"
import script from "./resourceInfo2.vue?vue&type=script&lang=js"
export * from "./resourceInfo2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports